<template>
    <div id="calcContainor">
        <iframe id="statis_luckysheet" src="/index_statistics.html" style="height: 100%;borderWidth: 0;width: 100%;"></iframe>
    </div>
</template>

<script>
    export default {
        name: 'StatisticsManage',
        props: {
            menuKey: String,
            default: ''
        },
        data() {
            return {};
        },
        mounted() {
            let that = this;
            setTimeout(function () {
                localStorage.setItem('statistic_menuKey_event', 'xxxxxx');
                localStorage.setItem('statistic_menuKey_event', that.menuKey);
            }, 500)
        },
        watch: {
            menuKey: function (newVal, oldVal) {
                localStorage.setItem('statistic_menuKey_event', newVal);
            }
        },
        methods: {},
    };
</script>

<style scoped>
    #calcContainor {
        width: 100%;
    }
</style>
